import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';
import type { RecordOf } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import type { chartOfAccountsTypes } from 'app-components/flux/chart-of-accounts';
import type { ProjectSelect } from 'components/ClientProjectSelect';
import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';
import type { SplitProps, TransactionProps } from 'app-components/flux/transactions/transactionsTypes';

export const DIALOG_TYPE = 'SPLIT_DIALOG';

export type SplitDialogMode = 'reminder' | 'series' | 'transaction';

export type ShowSplitDialogProps = {
  /** Optional dialog id; defaults to `SPLIT_DIALOG_${txn.id|txn.clientId|timestamp}`. */
  id?: string;
  title?: string;

  txn: TransactionProps;
  setSplit: (val: RecordOf<SplitProps> | null) => void;
  setAmount: (val: number) => void;
  setCoa: (newCOA?: chartOfAccountsTypes.ChartOfAccountProps | null) => void;
  setTags: (val: TransactionProps['tags']) => void;
  accountId: string;
  disabledPaymentFn: (bId: string) => boolean;
  setCustomersAndProjects: (value: ProjectSelect) => void;
  mode?: SplitDialogMode;
  readOnly?: boolean;
  rootModalDrawer?: RootModalDrawerOptions;

  /**
   * Optional close handlers. If omitted, the dialog will still render, but callers should
   * prefer providing these to ensure the dialog is removed from RootModal.
   */
  onClose?: () => void;
  onBack?: () => void;
};

export const showSplitDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ id, ...props }: ShowSplitDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: id ?? `SPLIT_DIALOG_${props.txn?.id || props.txn?.clientId || Date.now()}`,
      props: ImmutableMap({
        ...props,
        open: true,
      }),
    }),
);
